import { createFocusTrap } from 'focus-trap'
import 'swiped-events'

const container = document.getElementById('js-search-index')

const toggleFilters = () => {
  const filtersEl = document.getElementById('js-search-filters')
  const filtersOverlay = document.getElementById('js-filters-overlay')
  const backToTopEl = document.getElementsByClassName('js-back-to-top').length
    ? document.getElementsByClassName('js-back-to-top')[0]
    : null
  const elClass = 'js-search-filters-toggle'
  const activeClass = 'c-filters--active'
  const focusTrap = createFocusTrap(filtersEl, {
    initialFocus: document.getElementById('js-search-filters-header'),
    clickOutsideDeactivates: true,
  })

  if (!container) return

  const handleFocus = () => {
    // trap the tab focus in the filters window
    if (filtersEl.classList.contains(activeClass)) {
      return focusTrap.activate()
    }
    return focusTrap.deactivate()
  }

  const handleToggle = () => {
    // return early if no values
    if (!filtersEl?.classList || !filtersOverlay?.classList) {
      return
    }

    filtersEl.classList.toggle(activeClass)
    filtersOverlay.classList.toggle('block')
    document.body.classList.toggle('c-filters--locked')

    if (backToTopEl?.classList) {
      backToTopEl.classList.toggle('hidden')
    }
    handleFocus()
  }

  const handleTabIndex = () => {
    /* 
      adjust tab index depending if the filters are visible on the screen or not, 
      the element can't use display none because of the transition,
      this avoids tabbing an invisible element that exists in the DOM
    */
    if (
      window.outerWidth <= 820 &&
      filtersEl.classList.contains(activeClass) === false
    ) {
      return (filtersEl.tabIndex = -1)
    }
    return (filtersEl.tabIndex = 0)
  }
  handleTabIndex()

  // key actions
  document.addEventListener('keydown', (e) => {
    if (!filtersEl.classList.contains(activeClass)) return

    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault()
      handleToggle()
    }
  })

  // click actions
  document.addEventListener('click', (e) => {
    if (
      e.target.classList.contains(elClass) ||
      e.target.parentNode.classList.contains(elClass)
    ) {
      e.preventDefault()
      handleToggle()
    } else if (
      filtersEl.classList.contains(activeClass) &&
      !filtersEl.contains(e.target)
    ) {
      e.preventDefault()
      handleToggle()
    }
  })

  // resize actions
  window.addEventListener('resize', function () {
    setTimeout(function () {
      handleTabIndex()
    }, 1000)
  })

  // swipe actions
  document.addEventListener('swiped-left', function (e) {
    handleToggle()
  })
}

const handleEmpty = () => {
  const labels = document.querySelectorAll('.js-filter-label')
  const labelsArr = Array.from(labels)

  if (!labelsArr.length) return

  labelsArr.forEach((el) => {
    const childItem = el.nextElementSibling

    if (!childItem) return

    const childItemFilter = childItem.querySelector('div')

    // Show/hide label and inputs based on whether there are options
    if (childItemFilter) {
      if (
        childItemFilter.classList.contains('js-no-filter-options') === false
      ) {
        el.classList.remove('hidden')
        childItem.classList.remove('hidden')
      } else {
        el.classList.add('hidden')
        childItem.classList.add('hidden')
      }
    }
  })
}

export { toggleFilters, handleEmpty }
